import type { Nullable } from '@ats/interfaces';
import styled from '@emotion/styled';
import type { AspectRatio } from '@hooks/ref/useElementAspectRatio';
import type { VideoGridProps } from './';

interface GridContainerProps extends VideoGridProps {
  ratio?: Nullable<AspectRatio>;
  size: number;
  featured: boolean;
}

export const Container = styled.div<GridContainerProps>`
  position: relative;
  justify-content: center;
  margin: auto;
  gap: 8px;
  font-size: 0;
  max-height: 100%;
  flex-direction: column;
  display: flex;
  height: 100%;
  max-width: 100%;
  border-radius: 6px;
  aspect-ratio: 16 / 9;

  & > div:nth-of-type(2) {
    flex: 240px 1 0;
    margin: auto;
    width: 320px;
  }
`;
